import { userConstants } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import useUserChannel from './useUserChannel';

// Real-time tracked card for the current (logged-in) user's stopwatch button.
// Subscribes to the current user's UserChannel and pushes each update into redux.
function useTimestampActionCable() {
    const dispatch = useDispatch();

    const { getCommonData } = useSelector(state => state.dashboard);
    const userId = getCommonData?.current_user?.id;

    const { connected } = useUserChannel({
        userId,
        onUpdate: (data) => dispatch({ type: userConstants.TRACKED_CARD_ADD, payload: data }),
    });

    return { connected };
}

export default useTimestampActionCable;
